import { StandardEvents } from '@shopify/events';

const drawer = document.getElementById('hu-cart-drawer');
if (drawer && !window.hairUPCart) {
  const sectionId = 'hairup-cart-drawer';
  const root = window.Shopify?.routes?.root || '/';
  let busy = false;
  let opener;
  let version = 0;
  const content = () => drawer.querySelector('[data-hu-cart-content]');
  function error(message) {
    const el = drawer.querySelector('[data-hu-cart-error]');
    el.textContent = message;
    el.hidden = false;
  }
  function count() {
    const quantity = content().dataset.count;
    document.querySelectorAll('[data-hu-cart-open]').forEach(link => {
      link.setAttribute('aria-label', `Koszyk, produktów: ${quantity}`);
      const badge = link.querySelector('.hu-hd__count');
      if (badge) { badge.textContent = quantity; badge.hidden = Number(quantity) === 0; }
    });
  }
  function render(sections) {
    const html = sections?.[sectionId];
    if (!html) return false;
    const next = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-hu-cart-content]');
    if (!next) return false;
    const active = document.activeElement;
    const line = active?.closest('[data-hu-cart-line]');
    const key = line?.dataset.key;
    const delta = active?.getAttribute('data-hu-cart-delta');
    const scroll = drawer.querySelector('.hu-cd__scroll').scrollTop;
    content().replaceWith(next);
    drawer.querySelector('.hu-cd__scroll').scrollTop = scroll;
    count();
    if (drawer.open) {
      const row = [...drawer.querySelectorAll('[data-hu-cart-line]')].find(el => el.dataset.key === key);
      const focus = row && delta ? row.querySelector(`[data-hu-cart-delta="${delta}"]`) : null;
      (focus || drawer.querySelector('[data-hu-cart-close]')).focus({preventScroll:true});
    }
    return true;
  }
  async function refresh() {
    const request = ++version;
    const url = new URL(window.location.href);
    url.searchParams.set('section_id', sectionId);
    url.searchParams.set('preview_theme_id', drawer.dataset.themeId);
    const res = await fetch(url, {headers:{Accept:'text/html'}, cache:'no-store'});
    if (!res.ok) throw new Error('Nie udało się odświeżyć koszyka. Otwórz pełny koszyk poniżej.');
    const html = await res.text();
    const sections = {[sectionId]: html};
    if (request === version && !render(sections)) throw new Error('Otwórz pełny koszyk, aby sprawdzić zamówienie.');
  }
  function open() {
    if (!drawer.open) {
      opener = document.activeElement;
      drawer.showModal();
    }
  }
  async function added(sections) {
    ++version;
    open();
    if (!render(sections)) {
      try { await refresh(); }
      catch { error('Produkt dodany. Nie udało się odświeżyć podglądu. Otwórz pełny koszyk poniżej.'); }
    }
  }
  function lock(value) {
    busy = value;
    drawer.setAttribute('aria-busy', String(value));
    drawer.querySelectorAll('[data-hu-cart-delta], [data-hu-cart-remove], [name="checkout"]').forEach(b => { b.disabled = value; });
  }
  document.addEventListener('click', async event => {
    const link = event.target.closest('[data-hu-cart-open]');
    if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.button > 0) return;
    event.preventDefault();
    open();
    if (busy) return;
    lock(true);
    try { await refresh(); } catch (ex) { error(ex.message); } finally { lock(false); }
  });
  drawer.addEventListener('click', async event => {
    if (event.target.closest('[data-hu-cart-close]')) { drawer.close(); return; }
    if (event.target === drawer) {
      const rect = drawer.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right) drawer.close();
      return;
    }
    const button = event.target.closest('[data-hu-cart-delta], [data-hu-cart-remove]');
    if (!button || busy) return;
    const line = button.closest('[data-hu-cart-line]');
    const quantity = button.hasAttribute('data-hu-cart-remove') ? 0 : Number(line.dataset.quantity) + Number(button.dataset.huCartDelta);
    lock(true);
    ++version;
    try {
      const res = await fetch(root + 'cart/change.js', {
        method:'POST', headers:{'Content-Type':'application/json', Accept:'application/json'},
        body:JSON.stringify({id:line.dataset.key,quantity,sections:[sectionId],sections_url:root + 'cart'})
      });
      const result = await res.json();
      if (!res.ok) throw new Error(result.description || result.message || 'Nie udało się zmienić ilości.');
      if (!render(result.sections)) await refresh();
    } catch (ex) {
      try { await refresh(); } catch { /* Link do pelnego koszyka pozostaje dostepny. */ }
      error(ex.message || 'Sprawdź połączenie i otwórz pełny koszyk.');
    } finally { lock(false); }
  });
  drawer.addEventListener('close', () => { if (opener?.isConnected && !opener.disabled) opener.focus({preventScroll:true}); });
  window.hairUPCart = {added, refresh, open, sectionId};
  document.addEventListener(StandardEvents.cartLinesUpdate, event => {
    if (!event.promise) return;
    event.promise.then(result => {
      if (result.detail?.source === 'product-form-component' && !result.detail?.didError) return added(result.detail?.sections);
    }).catch(() => {});
  });
  count();
}
